import { render } from "./PriceGridMoq.vue?vue&type=template&id=06c382cb"
import script from "./PriceGridMoq.vue?vue&type=script&lang=js"
export * from "./PriceGridMoq.vue?vue&type=script&lang=js"

import "./PriceGridMoq.vue?vue&type=style&index=0&id=06c382cb&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__